import React, {Component} from 'react';
import intl from 'react-intl-universal';
import { inject } from 'mobx-react';
import CrossfadeImage from 'react-crossfade-image';

import './LayerToggle.css';

@inject("appStore")
class LayerToggle extends Component {
    constructor(props){
        super(props);
        this.timeout = null;
        this.force = false;
    }
    returnLayerImage = () => {
        const showSatellite = this.props.mode === 'RoadMap';
        const layerId = this.props.layers[showSatellite ? 'Satellite' : 'RoadMap'];
        const zoom = this.props.map.viewport.zoom - 3;

        let prefix;
        if (layerId.static) {
            prefix = `https://api.mapbox.com/styles/v1/mapbox/${layerId.static}`;
        } else {
            prefix = `https://api.mapbox.com/styles/v1/tadiraman/${layerId}`;
        }

        return `${prefix}/static/${this.props.center.lng},${this.props.center.lat},${zoom},0,0/120x140?access_token=pk.eyJ1IjoidGFkaXJhbWFuIiwiYSI6IktzUnNGa28ifQ.PY_hnRMhS94SZmIR2AIgug`;
    };

    shouldComponentUpdate(nextProps){
        clearTimeout(this.timeout);
        this.force = false;
        if (nextProps.mode !== this.props.mode){
            this.force = true;
            this.forceUpdate();
        } else {
            this.timeout = setTimeout(() => {
                this.forceUpdate();
            }, 1000);
        }
        return false;
    }
    componentWillUnmount = () => {
        clearTimeout(this.timeout);
    };
    render =()=> {
        const showSatellite = this.props.mode === 'RoadMap';//CODE-REVIEW:RAJ: this is not consistent with case. also we should not be doing this hard coded, should come from boolean flag from appconfig

        let delay = (this.force) ? 100 : 2000;
        let duration = (this.force) ? 1000 : 1000;

        return (
            <div className={"LayerToggle " + (showSatellite ? 'satellite' : 'road-map')}
                 onClick={() => {
                     this.props.appStore.toggleMapMode(); }
                 }>
                <span>{showSatellite ? intl.get("LayerToggle.satellite") : intl.get("LayerToggle.roadmap")}</span>
                <CrossfadeImage className={'InnerLayerToggle'}
                                src={this.returnLayerImage()}
                                alt={this.props.mode}
                                delay={delay}
                                duration={duration}
                                timingFunction={"ease-out"}
                />
            </div>
        );
    }
}

export default LayerToggle;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/LayerToggle/index.js